/** @format */

import { CartItemV2 } from './cart-item-v2.interface';

export interface CartV2 {
  items: CartItemV2[];
  messaging: string[];
  paypalable: boolean;
  containsScorecardPlusProduct: boolean;
  scorecardPlusMember: boolean;
}
